import { SOL_BALANCE, USDC_BALANCE, TIME_CREDIT, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    sol: 0,
    usdc: 0,
    timeCredit: 0
}

export const allCoinBalanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SOL_BALANCE:
            return {
                ...state,
                sol: action.payload
            }
        case USDC_BALANCE:
            return {
                ...state,
                usdc: action.payload
            }
        case TIME_CREDIT:
            return {
                ...state,
                timeCredit: action.payload
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}